/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-17, 09:39:21
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-25, 12:36:38
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// Vuex Payment module mutations

import {
  FILL_PAYMENT_PARAMS, SET_TOKEN_VALIDATION_STATE,
  FILL_SALES_SERVICE_POINT_DATA, SET_GATEWAY_URL,
  TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY,
  TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA,
  ENABLE_SUBMIT_PAYMENT,
  DISABLE_SUBMIT_PAYMENT,
  SET_SELECTED_GATEWAY, SET_CREDIT_CARD_DATA, SET_LANGUAGE,
} from './mutations-types';

export default {
  [FILL_PAYMENT_PARAMS](state, payload) {
    const _state = state;
    _state.params = payload.params;
  },

  [FILL_SALES_SERVICE_POINT_DATA](state, payload) {
    const _state = state;
    _state.saleServicePoint = payload.saleServicePoint;
  },

  [SET_TOKEN_VALIDATION_STATE](state, payload) {
    const _state = state;
    _state.tokenIsValid = payload.isValid;
  },

  [SET_GATEWAY_URL](state, payload) {
    const _state = state;
    _state.gatewayUrl = payload.gatewayUrl;
  },

  [TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY](state, payload = {}) {
    const _state = state;
    _state.isWaitingForRedirectionToPaymentGateway = payload.state || !_state.isWaitingForRedirectionToPaymentGateway;
  },

  [TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA](state) {
    const _state = state;
    _state.isWaitingForSaleServicePointData = !_state.isWaitingForSaleServicePointData;
  },

  [ENABLE_SUBMIT_PAYMENT](state) {
    const _state = state;
    _state.canSubmitPayment = true;
  },

  [DISABLE_SUBMIT_PAYMENT](state) {
    const _state = state;
    _state.canSubmitPayment = false;
  },

  [SET_SELECTED_GATEWAY](state, payload) {
    const _state = state;
    _state.selectedGateway = payload.uuid;
  },

  [SET_CREDIT_CARD_DATA](state, payload) {
    const _state = state;
    _state.creditCardData.firstName = payload.firstName;
    _state.creditCardData.lastName = payload.lastName;
    _state.creditCardData.email = payload.email;
    _state.creditCardData.number = payload.cardNumber;
    _state.creditCardData.cvv = payload.cardCvv;
    _state.creditCardData.expirationYear = payload.cardExpYear;
    _state.creditCardData.expirationMonth = payload.cardExpMonth;
  },

  [SET_LANGUAGE](state, payload) {
    const _state = state;
    _state.params.lang = payload.lang;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Payment/mutations.js